import { removeLogicFromText, removeTagsFromText } from '@aytm/app/stats/page/components/lib/utils'
import { buildPlaceholderMultiSelect } from '@aytm/app/stats/page/question-views/components/lib/select-utils'

const convertNumberToString = value => String(value)

const resolveOptionValue = item => {
  if (item?.value != null) return convertNumberToString(item.value)
  if (item?.position != null) return convertNumberToString(item.position)
  return ''
}

export const prepareOptionsForControls = data =>
  data.map(item => {
    return {
      value: resolveOptionValue(item),
      text: removeTagsFromText(removeLogicFromText(item?.text ?? '')) // ?? — default param does not fire for null
    }
  })

export const convertArrayToStrings = value => value.map(item => convertNumberToString(item))

export const prepareOptionsChartLegends = (data, chartLegendMode) => {
  const result = prepareOptionsForControls(data)

  return result.map(item => {
    const text = `${item.text} ${chartLegendMode === 'long' ? '' : `(E: ${item.value})`}`
    return { ...item, text }
  })
}

export const getPlaceholder = (value = [], data = []) =>
  buildPlaceholderMultiSelect(value, data, {
    empty: 'Select...',
    multiple: count => `Filtered to ${count}`
  })
